import { render, staticRenderFns } from "./v-input-auth-code.vue?vue&type=template&id=515fe70a&scoped=true&"
import script from "./v-input-auth-code.vue?vue&type=script&lang=js&"
export * from "./v-input-auth-code.vue?vue&type=script&lang=js&"
import style0 from "./v-input-auth-code.vue?vue&type=style&index=0&id=515fe70a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fe70a",
  null
  
)

export default component.exports